import { useContext } from 'react';
import { ModalContext } from '../providers/Modal';

export const useModal = () => useContext(ModalContext);
